/* eslint-disable @typescript-eslint/prefer-for-of */
import React from 'react';

const QuantitySelect = (props) => {
  const quantityArray = () => {
    const foo = [];
    for (let i = 1; i <= 200; i++) {
      foo.push(i);
    }
    return foo;
  };

  const optionsArray = props.isKalogris ? [5, 10, 25, 50, 100, 250, 500, 1000] : quantityArray();

  return (
    <select {...props}>
      {optionsArray.map((i) => (
        <option key={i} value={i}>
          {i}
        </option>
      ))}
    </select>
  );
};

export default QuantitySelect;
